<template>
  <div>
    <div
      class="video-container"
      ref="app"
      @mousedown="startDrawingBox"
      @mousemove="changeBox"
      @mouseup="stopDrawingBox"
    >
      <Box
        v-if="drawingBox.active"
        :b-width="drawingBox.width"
        :b-height="drawingBox.height"
        :b-top="drawingBox.top"
        :b-left="drawingBox.left"
      />

      <Box
        v-for="(box, i) in scaledBoxes"
        :key="i"
        :b-top="box.top"
        :b-left="box.left"
        :b-label="box.label"
        :b-width="box.width"
        :b-height="box.height"
        :b-active="i === activeBoxIndex"
        :on-select="makeBoxActive"
        :b-index="i"
        :on-delete="removeBox"
      />

      <heatmapjs-vue
        class="heatmapjs-container"
        :max="max"
        :min="min"
        :data="eyeData"
        :options="options"
        :move-drawable="moveDrawable"
        :click-drawable="clickDrawable"
        :draw-value="drawValue"
      ></heatmapjs-vue>
      <img v-if="selected" :src="selected.screenshot.url" alt="" />
      <resize-observer @notify="handleResize" />
    </div>
    <!--
    <div id="label-bar">
        <h4>Your boxes</h4>
        <ul>
            <li v-for="(box, i) in boxes" :key="i" 
                v-bind:class="{'active': i===activeBoxIndex}">
                <input v-model="box.label" 
                v-on:click="makeBoxActive(i)"/>
                <a @click="removeBox(i)">x</a>
            </li>
        </ul>
        <h3>Selected box index {{activeBoxIndex}}</h3>
        <p v-if="this.activeBoxIndex != null">Fixations: {{ fixations }}</p>
        <p v-if="this.activeBoxIndex != null">Participants: {{ participantsCount.length }}</p>
        <p v-if="this.activeBoxIndex != null">TTFF: {{ ttff }} milliseconds</p>

    </div>
    -->
  </div>
</template>

<style lang="scss" scoped>
#label-bar {
  float: right;
  margin-right: 50px;
  width: 220px;

  ul {
    padding: 0;

    li {
      list-style-type: none;
      padding: 8px 16px;

      &.active {
        background-color: lightblue;
      }

      a {
        cursor: pointer;
        display: inline-block;
        margin-left: 4px;
        font-weight: bold;
        color: red;
      }
    }
  }
}
</style>

<style scoped>
.video-container {
  position: relative;
  max-width: 1920px;
  margin-bottom: 150px;
}

.heatmapjs-container {
  width: 100%;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 6;
  pointer-events: none;
}

img {
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>

<script>
import Box from "./box";
import { pick } from "lodash";
import API from "@/api";
import Urlbox from "urlbox";

const getCoursorLeft = (e) => {
  return e.pageX - 314;
};

const getCoursorTop = (e) => {
  return e.pageY - 353;
};
export default {
  props: [
    "selected",
    "heightCorrection",
    "showFirst",
    "type",
    "showPp",
    "data",
    "participants",
  ],
  components: {
    Box,
  },
  watch: {
    activeBoxIndex: function () {
      if (this.activeBoxIndex != null) {
        this.$emit(
          "onSelectBox",
          this.ttff,
          this.participantsCount.length,
          this.fixations,
          this.activeBoxIndex
        );
      } else if (this.activeBoxIndex == null) {
        this.$emit("onSelectBox", "-", "-", "-", "-");
      }
    },
  },
  computed: {
    boxData: function () {
      const box = this.scaledBoxes[this.activeBoxIndex];
      let filtered;
      if (this.activeBoxIndex != null) {
        filtered = this.eyeData.filter(xy);
      }

      function xy(obj) {
        if (obj.y < box.top || obj.y > box.top + box.height) {
          return false;
        } else if (obj.x < box.left || obj.x > box.left + box.width) {
          return false;
        } else {
          return true;
        }
      }

      return filtered;
    },
    eyeData: function () {
      let scale = this.width / 1920;
      let newEyes = [];
      if (this.data.length > 4) {
        this.data.forEach((element) => {
          //if you only want fixations then filter on element.fixation
          newEyes.push({
            x: Math.floor(element.x * scale),
            y: Math.floor((element.y + element.scroll) * scale),
            value: Math.floor(element.value * scale),
            pp: element.pp,
            timestamp: element.timestamp,
            start: element.start,
          });
        });
      }
      if (this.showFirst != "All") {
        newEyes = newEyes.filter((obj) => {
          return obj.timestamp - obj.start < this.showFirst * 1000;
        });
        newEyes.forEach((el) => {
          if (el.value === 15) {
            el.value = 15;
          } else {
            el.value = 2;
          }
        });
      }

      if (this.showPp != "All") {
        newEyes = newEyes.filter((obj) => {
          return obj.pp == this.showPp.id;
        });
        newEyes.forEach((el) => {
          if (el.value === 15) {
            el.value = 80;
          } else {
            el.value = 10;
          }
        });
      }
      return newEyes;
    },
    mouseData: function () {
      // SAVE FOR LATER WHEN ADDING CLICK HEATMAP!
      // let mice = this.mice
      // let scale = this.width / 1920
      // let newMice = []
      // mice.forEach((element) => {
      //     newMice.push({
      //         x: Math.floor(element.x * scale),
      //         y: Math.floor((element.y + element.scroll_y) * scale),
      //         value: Math.floor(element.value * scale),
      //         pp: element.pp,
      //         timestamp: element.timestamp,
      //         start: element.start
      //     })
      // });
      // if (this.showFirst) {
      //     newMice = newMice.filter((obj) => {
      //         return ((obj.timestamp - obj.start) < (this.showFirst * 1000))
      //     })
      // }
      // return newMice
    },
    scaledBoxes: function () {
      let boxes = this.boxes;

      let converted = [];
      if (boxes.length > 0) {
        boxes.forEach((el) => {
          let scale = this.width / el.refWidth;

          converted.push({
            height: Math.floor(el.height * scale),
            width: Math.floor(el.width * scale),
            left: Math.floor(el.left * scale),
            top: Math.floor(el.top * scale),
          });
        });
      }

      return converted;
    },
    fixations: function () {
      let fixations = Math.floor(
        (this.boxData.length / this.eyeData.length) * 100
      );
      if (fixations < 1) {
        fixations = "< 1";
      }
      return String(fixations) + "%";
    },
    participantsCount: function () {
      let uniques = [];
      if (this.boxes.length > 0) {
        this.boxData.forEach((obj) => {
          if (!uniques.includes(obj.pp)) {
            uniques.push(obj.pp);
          }
        });
      }

      return uniques;
    },
    ttff: function () {
      let time = [];

      if (this.boxes.length > 0) {
        let pp = this.participants;
        if (pp[0] === "All") {
          pp.shift();
        }
        pp.forEach((pp) => {
          let start = null;
          let fastest = null;

          this.boxData.forEach((obj) => {
            if (obj.pp === pp.id) {
              start = obj.start;

              if (fastest === null || obj.timestamp < fastest) {
                fastest = obj.timestamp;
                time.push(fastest - start);
              }
            }
          });
        });
        const sum = time.reduce((a, b) => a + b, 0);
        const avg = sum / time.length || 0;
        return Math.floor(avg);
      } else {
        return 0;
      }
    },
  },
  data() {
    return {
      activeBoxIndex: null,
      show: true,
      width: 0,
      height: 0,
      max: 100,
      min: 0,
      moveDrawable: false,
      clickDrawable: false,
      drawValue: 5,
      options: {
        backgroundColor: "transparent",
      },
      drawingBox: {
        active: false,
        top: 0,
        left: 0,
        height: 0,
        width: 0,
      },
      boxes: [],
      refWidth: 0,
      // data: [],
      mice: [],
      heatmapData: [],
      screenshot: null,
      heatmaps: [],
    };
  },
  mounted() {},
  methods: {
    getScreenshot() {
      //TODO: get rid of this as we are uploading the image to the backend and the url comes with the heatmap object
      this.$emit("loading", true);
      const urlbox = Urlbox(
        "8wII7dOU3EGNmOFr",
        "ebcd185c3d2f49b198a257624c141416"
      );
      const options = {
        format: "png",
        click_accept: true,
        hide_cookie_banners: true,
        cookie: ["cookie=OptIn=true"],
        url: this.selected.url,
        full_page: true,
        height: "1080",
        width: "1920",
      };
      this.selected.screenshot = urlbox.buildUrl(options);
      this.$emit("loading", false);
    },
    handleResize({ width, height }) {
      this.width = width;
      this.height = height;
      this.refWidth = width;
    },
    startDrawingBox(e) {
      this.drawingBox = {
        width: 0,
        height: 0,
        top: getCoursorTop(e),
        left: getCoursorLeft(e),
        active: true,
      };
    },
    changeBox(e) {
      if (this.drawingBox.active) {
        this.drawingBox = {
          ...this.drawingBox,
          width: getCoursorLeft(e) - this.drawingBox.left,
          height: getCoursorTop(e) - this.drawingBox.top,
        };
      }
    },
    makeBoxActive(i) {
      this.activeBoxIndex = i;
    },
    removeBox(i) {
      this.boxes = this.boxes.filter((elem, index) => {
        return index !== i;
      });
      this.activeBoxIndex = null;
    },
    stopDrawingBox() {
      if (this.drawingBox.active) {
        if (this.drawingBox.width > 5) {
          this.boxes.push({
            width: this.drawingBox.width,
            height: this.drawingBox.height,
            top: this.drawingBox.top,
            left: this.drawingBox.left,
            refWidth: this.refWidth,
          });
        }
        this.drawingBox = {
          active: false,
          top: 0,
          left: 0,
          height: 0,
          width: 0,
        };
      }
    },
  },
};
</script>
